module.exports = __webpack_public_path__ + "static/media/bgWhiteDirt.0fe17404.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bgWhiteDirt.jpg
// module id = 26
// module chunks = 0